import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalRule  {
    _originalTypeClassName = "zERP.BO.GeneralJournalRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalRule.translate = translateService;
}
this.AccountingEvents = [];
this.Entity = new Domain.AccountingBusinessEntity();
this.BO = new Domain.AccountingSystemEntity();
this.Entries = [];
this.GeneralJournalRuleID = null;
this.RuleName = null;
this.RuleDescription = null;
this.isEnabled = false;
this.DatePosted = null;
this.Description = null;
this.CurrencyID = null;
this.RefDocumentID = null;
this.AccountingEventsDescription = null;
this._key = this.GeneralJournalRuleID = 0; 
}

static translate: TranslateService;
_key: any;
private _GeneralJournalRuleID:any;
get GeneralJournalRuleID(): any {
    return this._GeneralJournalRuleID;
  }
set GeneralJournalRuleID(value: any) {
    this._GeneralJournalRuleID = value;
    this._key = value;
  }
RuleName:any;
RuleDescription:any;
isEnabled:any;
DatePosted:any;
Description:any;
CurrencyID:any;
RefDocumentID:any;
AccountingEventsDescription:any;
FiscalPeriod:any;
AccountingEvents:any;
Entity:any;
BO:any;
Entries:any;
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setAccountingEvents = ($this, items) => {
                if (items == null) items = [];
                if ($this.AccountingEvents == null) $this.AccountingEvents = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AccountingEvents.length > 0) {
                    Domain.GeneralJournalRule.removeAccountingEvents($this, $this.AccountingEvents[0]);
                }

                Domain.GeneralJournalRule.addManyAccountingEvents($this, copyItems);
            }
static addManyAccountingEvents = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalRule.addAccountingEvents($this, items[i]);
                }
            }
static addAccountingEvents = ($this, item) => {
                if ($this.AccountingEvents == null) $this.AccountingEvents = [];
                if (item == null || $this.AccountingEvents.indexOf(item) > -1) return;
                $this.AccountingEvents.push(item);
}
static addRangeAccountingEvents = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalRule.addAccountingEvents($this, item));
            }
static removeAccountingEvents = ($this, item) => {
                if ($this == null || $this.AccountingEvents == null || $this.AccountingEvents.indexOf(item) === -1) return;
                var _index = $this.AccountingEvents.indexOf(item);
                $this.AccountingEvents.splice(_index, 1);
}
static clearAccountingEvents = ($this) => { $this.AccountingEvents = null; }
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setBO = ($this, value) => {
var oldValue = $this.BO;
$this.BO = value;
if (value != null) {
}
}
static setEntries = ($this, items) => {
                if (items == null) items = [];
                if ($this.Entries == null) $this.Entries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Entries.length > 0) {
                    Domain.GeneralJournalRule.removeEntries($this, $this.Entries[0]);
                }

                Domain.GeneralJournalRule.addManyEntries($this, copyItems);
            }
static addManyEntries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournalRule.addEntries($this, items[i]);
                }
            }
static addEntries = ($this, item) => {
                if ($this.Entries == null) $this.Entries = [];
                if (item == null || $this.Entries.indexOf(item) > -1) return;
                $this.Entries.push(item);
}
static addRangeEntries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournalRule.addEntries($this, item));
            }
static removeEntries = ($this, item) => {
                if ($this == null || $this.Entries == null || $this.Entries.indexOf(item) === -1) return;
                var _index = $this.Entries.indexOf(item);
                $this.Entries.splice(_index, 1);
}
static clearEntries = ($this) => { $this.Entries = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralJournalRuleID == null || $this.GeneralJournalRuleID == 0;
            }


}